import React, { useRef, useState, useEffect } from 'react';
import { Box, Chip, IconButton, Collapse } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';

export default function ChipCarousel({
  options,
  onClickHandler,
  selectDataTypeRef,
}: {
  options: any[];
  onClickHandler: any;
  selectDataTypeRef: any;
}) {
  const [showLeftArrow, setShowLeftArrow] = useState<any>(false);
  const [showRightArrow, setShowRightArrow] = useState<any>(false);
  const { t } = useTranslation('ui-elements');
  const scrollRef: any = useRef();

  const scroll = (direction: any) => {
    const scrollAmount = direction === 'left' ? -100 : 100;
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  const handleScroll = () => {
    const el = scrollRef.current;
    const scrollLeft = el.scrollLeft;
    const maxScroll = el.scrollWidth - el.clientWidth;

    setShowLeftArrow(scrollLeft > 0);
    setShowRightArrow(scrollLeft < maxScroll - 5); // 5px buffer
  };

  useEffect(() => {
    const el = scrollRef.current;
    handleScroll(); // initial check
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', overflow: 'hidden' }}>
      {/* Left Arrow */}
      <Collapse orientation="horizontal" in={showLeftArrow}>
        <IconButton onClick={() => scroll('left')}>
          <ArrowBackIosNewIcon sx={{ fontSize: '14px !important' }} color="secondary" />
        </IconButton>
      </Collapse>

      {/* Chip List */}
      <Box
        ref={scrollRef}
        sx={{
          display: 'flex',
          gap: '6px',
          overflowX: 'auto',
          scrollBehavior: 'smooth',

          flex: 1,
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {options &&
          options?.map((item: any) => (
            <Chip
              key={item?.label + item?.sub_label}
              label={`${item?.label?.includes('Optical') ? (item?.sub_label ? `${item?.label}-${item?.sub_label}` : item?.label) : item?.label}`}
              aria-label={`${item?.label}-${item?.sub_label}-chip`}
              variant={selectDataTypeRef.current?.includes(item?.value) ? 'filled' : 'outlined'}
              color={selectDataTypeRef.current?.includes(item?.value) ? 'secondary' : 'default'}
              onClick={() => onClickHandler && onClickHandler(item, true)}
              sx={{
                minWidth: 'fit-content',
                padding: '0px 2px',
                fontWeight: 500,
                borderRadius: '20px',
              }}
            />
          ))}
      </Box>

      {/* Right Arrow */}
      <Collapse orientation="horizontal" in={showRightArrow}>
        <IconButton onClick={() => scroll('right')}>
          <ArrowForwardIosIcon sx={{ fontSize: '14px !important' }} color="secondary" />
        </IconButton>
      </Collapse>
    </Box>
  );
}
